import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

export default function StarClub() {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/me/star-club");
      setData(r.data);
    } catch (err) {
      console.warn("Global Club load failed:", err?.message);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const completedClubs = data?.completed_entries || [];

  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Global Club</div>
      </div>

      {completedClubs.length > 0 && (
        <div className="lt-card p-6">
          <div className="overline mb-3 flex items-center gap-2"><Trophy size={14} className="text-[#D4AF37]" /> Clubs completed</div>
          <div className="flex flex-wrap gap-2">
            {completedClubs.map((c) => (
              <div key={c.id} className="px-3 py-1.5 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-xs gold-text tabular">
                Club {c.club}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="lt-card p-6">
        <div className="overline mb-3">Payout History</div>
        <div className="overflow-x-auto -mx-1">
        <table className="lt-table">
          <thead><tr><th>When</th><th>Club</th><th>Payout</th></tr></thead>
          <tbody>
            {(data?.history || []).map((h) => (
              <tr key={h.id}>
                <td className="text-neutral-400">{new Date(h.created_at).toLocaleString()}</td>
                <td>Club {h.club}</td>
                <td className="tabular gold-text">+${h.payout}</td>
              </tr>
            ))}
            {(data?.history || []).length === 0 && (
              <tr><td colSpan={3} className="text-center text-neutral-500 py-6">No payouts yet. Earn payouts when 5 IDs fill your slot in any club.</td></tr>
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
